import { render, staticRenderFns } from "./SmallSearch.vue?vue&type=template&id=09b1fca7&scoped=true&"
import script from "./SmallSearch.vue?vue&type=script&lang=js&"
export * from "./SmallSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1fca7",
  null
  
)

export default component.exports